import React from 'react';
import '../applications-css/Application.css'

export function DropdownMenu(props) {
  return(
    <div className="dropdown">
      <button data-testid="button-label" className="dropdown-button">{props.buttonLabel}</button>
      <div className="dropdown-content">
        {props.menuItems.map((value, index) => {
          let buttonTitle = "button-" + value.name
          return (
            <button data-testid={buttonTitle} key = {index} onClick = {e => value.onClick(e, index)}>
              {value.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default DropdownMenu;
